#import "../fragments/context-document-fragment.graphql"

query GetPrimaryContextDocument {
    primaryContextDocument {
        ...ContextDocumentFragment
        aiSuggestions {
            id
            content
        }
    }
}
